<template>
  <td v-if="renderCell" :class="className" 
    colspan="1" 
    :data-grid-col-index="columnIndex"  
    role="gridcell"
    >
    <AccessibleElSelect
      :prop="'test' + dataItem.IdUsuario"
      :withFormItem="false"
      v-model="valueTest"
      :options="getNestedValue(field, dataItem).map((x, index) => ({ id: index, name: x.Nombre }))"
      :id-prefix="'test' + dataItem.IdUsuario"
      @change="onChange"
    >
    </AccessibleElSelect>
  </td>
  <td
    v-else-if="renderArrow"
    key="'g' + columnIndex"
    :class="'k-group-cell'"
    colspan="1" 
    :data-grid-col-index="columnIndex"
    role="gridcell"
  ></td>
  <td
    v-else-if="columnIndex <= level"
    key='g-colspan'
    :colSpan="columnsCount - columnIndex"
    :data-grid-col-index="columnIndex"
    role="gridcell"
  >
    <p class='k-reset'>
      <a
        @click="onClick"
        tabIndex='-1'
        href='#'
        :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'"
      />
      {{ dataItem[field] }}
    </p>
  </td>
</template>
<script>
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
function nestedValue (fieldName, dataItem) {
  const path = fieldName.split('.')
  let data = dataItem
  path.forEach((p) => {
    data = data ? data[p] : undefined
  })

  return data
}

export default {
  components: {
    AccessibleElSelect,
  },
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String
  },
  data () {
    return {
      valueTest: null,
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      return returnValue && this.dataItem[this.field]
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    }
  },
  methods: {
    onChange (value) {
      this.$emit('selectChange', {
        dataItemId: this.dataItem.IdUsuario,
        selectedValue: value,
        dataItem: this.dataItem
      })
    },
    goToUrl () {
      window.open(this.dataItem.URLRecibo)
    },
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    getNestedValue: nestedValue
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
